export default {
  rankOrder: {
    ariaAddOption: '{label} zur Rangliste hinzufügen',
    ariaMoveUp: '{label} nach oben verschieben',
    ariaMoveDown: '{label} nach unten verschieben',
    ariaRemoveOption: '{label} aus der Rangliste entfernen',
  },
  coe: {
    ariaDisclaimer: 'Hinweis',
    ariaQuestion: 'Frage',
    ariaConversationHistory: 'Gesprächsverlauf',
    ariaYourResponse: 'Ihre Antwort {number}',
    ariaFollowUpQuestion: 'Folgefrage {number}',
    ariaResponseInput: 'Antwortfeld',
    ariaRespondingTo: 'Antworten auf',
    ariaSendResponse: 'Antwort senden',
    ariaThinking: 'Denken'
  },
  deviceView: {
    toolbar: 'Vorschaugerät',
    mobile: 'Mobilgerät',
    tablet: 'Tablet',
    desktop: 'Desktop'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'QuestDIY-Logo'
  }
}
